import script from "./AccentLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AccentLink.vue?vue&type=script&setup=true&lang=js"

import "./AccentLink.vue?vue&type=style&index=0&id=552fcb69&lang=scss&scoped=true"
script.__scopeId = "data-v-552fcb69"

export default script